import React from 'react';

type Props = { children: React.ReactNode };
type State = { error: Error | null };

export default class ErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error) {
    console.error('ErrorBoundary:', error);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen bg-scout-cream flex items-center justify-center p-6">
          <div className="max-w-lg w-full rounded-xl border border-red-200 bg-white p-6 shadow-md">
            <h1 className="text-lg font-semibold text-red-800">Error en la aplicación</h1>
            <p className="mt-2 text-sm text-slate-600 break-words">{this.state.error.message}</p>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="mt-4 rounded-lg bg-scout-green px-4 py-2 text-sm font-medium text-white hover:bg-scout-green-dark"
            >
              Recargar página
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
